import { Container } from "../../components/layout/Container.jsx";
import { PageHero } from "../../components/shared/PageHero.jsx";
import { InquiryForm } from "../../components/forms/InquiryForm.jsx";
import { SEO } from "../../lib/seo.jsx";

export default function MaintenancePage() {
  return (
    <>
      <SEO
        title="Maintenance"
        description="Existing homeowners — log a maintenance request or warranty claim."
      />

      <PageHero
        eyebrow="Maintenance"
        title="Maintenance request"
        description="Existing homeowner? Log the issue here and our maintenance team will get back to you within one business day."
      />

      <Container className="py-16 lg:py-20">
        <div className="mx-auto max-w-2xl rounded-2xl border border-border-subtle bg-bg-elevated p-8">
          <p className="text-sm text-text-secondary">
            Please include your build address and a description of the issue. For urgent structural
            or water-related issues, please also call us directly.
          </p>
          <div className="mt-6">
            <InquiryForm
              formType="maintenance"
              successMessage="Thanks — our maintenance team will be in touch shortly."
            />
          </div>
        </div>
      </Container>
    </>
  );
}
